// extracted by mini-css-extract-plugin
module.exports = {"link":"inButton_link__H2G95","activeLink":"inButton_activeLink__3tpuQ"};